export default __webpack_public_path__ + "static/media/6.250b6e53.jpg";